import ShowMoreIcon from '@atlaskit/icon/core/align-left';
import { token } from '@atlaskit/tokens';
import { MenuLinkItem } from '@atlassian/navigation-system/v4';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { useRouter } from 'react-resource-router';

import { useAnalytics } from '@townsquare/analytics';
import { APPS_PATH } from '@townsquare/config/routes';
import { SideNavSwitcher } from '@townsquare/embeddable-switcher';
import { useOrgContextCloudIds } from '@townsquare/org-context';
import { useGeneratePath } from '@townsquare/router/primitives';
import { tagsDirectoryRoute } from '@townsquare/tags-directory-view/route';
import { openInNewTab } from '@townsquare/ui-interactions';

export const SwitcherLinks = () => {
  const orgContextCloudIds = useOrgContextCloudIds();

  const analytics = useAnalytics();
  const [routerStore, routerActions] = useRouter();

  const selectedKey = routerStore.match.url;

  const isViewAllSelected = useGeneratePath(tagsDirectoryRoute) === selectedKey || selectedKey === APPS_PATH;

  return (
    <SideNavSwitcher cloudIdsToFilterFor={orgContextCloudIds}>
      <MenuLinkItem
        onClick={e => {
          e.preventDefault();
          if (e.metaKey) {
            openInNewTab(APPS_PATH);
          } else {
            void routerActions.push(APPS_PATH);
          }
          void analytics.ui('sideNavItem', 'clicked', {
            screen: routerStore.route.name,
            navName: 'apps',
            navPath: APPS_PATH,
          });
        }}
        isSelected={isViewAllSelected}
        href={APPS_PATH}
        elemBefore={<ShowMoreIcon label="" color={isViewAllSelected ? token('color.icon.selected') : undefined} />}
        data-testid="side-nav-apps-view-all"
      >
        <FormattedMessage
          id="townsquare.atlassian-home.side-nav.view-all-apps"
          description="Side nav button under a list of some of the user's Atlassian product instances to go to a dedicated Apps page to list all apps"
          defaultMessage="View all apps"
        />
      </MenuLinkItem>
    </SideNavSwitcher>
  );
};
